import { render, staticRenderFns } from "./SurveyResults.vue?vue&type=template&id=52ad2150&scoped=true"
import script from "./SurveyResults.vue?vue&type=script&lang=js"
export * from "./SurveyResults.vue?vue&type=script&lang=js"
import style0 from "./SurveyResults.vue?vue&type=style&index=0&id=52ad2150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ad2150",
  null
  
)

export default component.exports